import React, { Component, createRef, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import LanguageList from '@app/components/ui/selects/LanguageList'
import { h } from '@app/helpers/translationHelper'
import classnames from 'classnames'
import { heading, dates } from '@app/components/shared/StateLabel/Label'
import LeaveModal from '@app/components/shared/LeaveModal'
import { profilePath } from '@app/helpers/applicationHelper'
import LogoutLink from '@app/components/ui/buttons/LogoutLink'
import { teacherTabs, parentTabs } from '@app/helpers/menusHelper'
import { defineTeacherAbilities, defineParentAbilities } from '@app/ability'
import AnalyticsManager, { PageEventsTypes } from '@app/analytics/manager'

import SVG from 'react-inlinesvg'
import menuIcon from '@icons/menu/button'
import moreIcon from '@icons/more/button'
import homeIcon from '@icons/home/red'
import rulesIcon from '@icons/rules/blue'
import agreementIcon from '@icons/agreement/blue'
import privacyIcon from '@icons/privacy/blue'
import profileIcon from '@icons/profile/blue'
import LogoutIcon from '@icons/logout/blue'
import arrowLeft from '@icons/arrow-left'

import Modal from '@app/components/ui/modals/Modal'

class Headbar extends Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.handleStay = this.handleStay.bind(this)
    this.handleLeave = this.handleLeave.bind(this)

    this.leftModal = createRef(null)
    this.rightModal = createRef(null)
    this.leaveModal = createRef(null)
  }

  handleClick(e, ref) {
    ref.current.open()
  }

  isMainTourActive() {
    const { user } = this.props

    return user &&
      user.participation &&
      user.participation.timeRemaining > 0 &&
      user.participation.tour === 'main'
  }

  handleBackClick = () => {
    if (this.isMainTourActive()) {
      this.leaveModal.current.open()
    } else {
      this.handleLeave()
    }
  }

  handleStay() {
    this.leaveModal.current.close()
  }

  handleLeave() {
    AnalyticsManager.emitPageEvent(PageEventsTypes.OlympBackClick)
    window.location.href = window.PLATFORM_URL + '/home'
  }

  renderContextMenu(tabs) {
    return _.map(tabs, ({ to, content, icon }) => {
      return (
        <Link to={to} className="select-list__item" key={`headbar-link-${to}`}>
          <div className="select-list__mark">
            { icon ? (<SVG src={icon} />) : null }
          </div>
          <div className="select-list__option">
            { content }
          </div>
        </Link>
      )
    })
  }

  renderUserMenu() {
    const { user, route, global } = this.props;

    if (!user || user.isStudent) {
      return (
        <Link to="/" className="select-list__item">
          <div className="select-list__mark">
            <SVG src={homeIcon} />
          </div>
          <div className="select-list__option">
            {I18n.t("headbar.navigation.home")}
          </div>
        </Link>
      )
    }
    else if (user.isTeacher) {
      return this.renderContextMenu(
        teacherTabs(
          defineTeacherAbilities(user, global),
          route
        )
      )
    }
    else if (user.isParent) {
      return this.renderContextMenu(
        parentTabs(
          defineParentAbilities(user, global),
          route
        )
      )
    }
    else {
      return null;
    }
  }

  render() {
    const { global: { languages, countries, event }, className, user } = this.props;

    return (
      <Fragment>
        <div className={classnames("headbar", className)}>
          <div className="headbar__content h-flex-layout" style={{ position: 'relative' }}>
            <div className="headbar__back-btn" onClick={this.handleBackClick}>
              <SVG src={arrowLeft} /> BACK
            </div>
            <div className="h-flex-layout__left">
              <div className="hidden w-flex-layout w-flex-layout--ai-left">
                <a
                  href="javascript:void(0)"
                  className="link link__icon link--text-white link--small link--no-hover"
                  onClick={(e) => this.handleClick(e, this.leftModal)}
                >
                  <SVG src={menuIcon} />
                  <span className="hide-mobile headbar__menu-label-l f--upper">
                    {I18n.t("headbar.language")}
                  </span>
                </a>
              </div>
            </div>
            <Link to="/" className="h-flex-layout__center headbar__logo">
              <img src={event.logo} />
            </Link>
            <div className="h-flex-layout__right">
            </div>
          </div>
        </div>

        <LeaveModal
          modal={this.leaveModal}
          onStay={this.handleStay}
          onLeave={this.handleLeave}
        />

        <Modal ref={this.leftModal} closeButton={false} className="modal--slider" theme="slider-left">
          <div className="p-1 pb-0">
            <LanguageList languages={languages} />
          </div>
          <div className="separator" />
          <div className="hidden pl-1 pr-1">
          </div>
        </Modal>

        <Modal ref={this.rightModal} closeButton={false} className="modal--slider" theme="slider-right">
          <div className="p-1 pb-0">
            <div className="select-list">
              { this.renderUserMenu() }
            </div>
          </div>
          <div className="separator" />

          <div className="select-list pl-1 pr-1">
            <Link to="/rules" className="select-list__item">
              <div className="select-list__mark">
                <SVG src={rulesIcon} />
              </div>
              <div className="select-list__option">
                { I18n.t('landing.rules_html') }
              </div>
            </Link>
          </div>

          <div className="separator" />

          { user ? (
              <div className="select-list pl-1 pr-1">
                <div className="select-list__item">
                  <div className="select-list__mark select-list__mark--auto ml-0">
                    <SVG src={profileIcon} />
                  </div>
                  <div className="select-list__option">
                    <span className="f--regular">{ user.fullName }</span>
                  </div>
                </div>
                <div className="w-flex-layout w-flex-layout--columns w-flex-layout--ai-left">
                  { user.isStudent ? null : (
                      <Link to={profilePath(user)} className="link f--upper mt-1 mb-1">
                        { I18n.t('teachers.edit.profile') }
                      </Link>
                    )
                  }

                  <LogoutLink className="link f--upper mt-0">
                    { I18n.t('auth.sign_out') }
                    <SVG src={LogoutIcon} />
                  </LogoutLink>
                </div>
              </div>
            ) : null
          }

        </Modal>
      </Fragment>
    )
  }
}

Headbar.propTypes = {
  user: PropTypes.object,
  route: PropTypes.object.isRequired,
  global: PropTypes.object.isRequired
}

export default Headbar
